import { Flex } from '@chakra-ui/react';

import { DialogOrDrawer } from '../DialogOrDrawer';
import { SwapDialog } from '../SwapDialog/SwapDialog';
import { H2FromTokenCard } from './components/H2SwapForm/H2FromTokenCard';
import { H2SwapExchangeRate } from './components/H2SwapForm/H2SwapExchangeRate';
import { H2ToTokenCard } from './components/H2SwapForm/H2ToTokenCard';
import { H2SwapSlippageDialog } from './components/H2SwapSlippageDialog/H2SwapSlippageDialog';
import { useH2SwapSlippageDialog } from './components/H2SwapSlippageDialog/useH2SwapSlippageDialog';
import { H2MinReceive } from './H2MinReceive';
import H2PriceImpact from './H2PriceImpact';
import H2SlippageTolerance from './H2SlippageTolerance';
import { H2SwapConfirmButton } from './H2SwapConfirmButton';
import { H2SwapGasFee } from './H2SwapGasFee';
import { useH2SwapDialog } from './useH2SwapDialog';

export const H2SwapDialog = () => {
  const isOpen = useH2SwapDialog((state) => state.isOpen);
  const close = useH2SwapDialog((state) => state.close);
  const closable = useH2SwapDialog((state) => state.closable);
  const isSlippageDialogOpen = useH2SwapSlippageDialog((s) => s.isOpen);

  return (
    <>
      <SwapDialog
        isOpen={isOpen && !isSlippageDialogOpen}
        close={close}
        closable={closable}
      >
        <DialogOrDrawer.Body pt="20px">
          <H2FromTokenCard />
          <H2SwapExchangeRate mb="16px" />
          <H2ToTokenCard />
        </DialogOrDrawer.Body>
        <DialogOrDrawer.Footer alignItems="stretch">
          <Flex flexDir="column" gap="8px">
            <H2MinReceive />
            <H2SlippageTolerance />
            <H2PriceImpact />
            <H2SwapGasFee />
          </Flex>
          <H2SwapConfirmButton />
        </DialogOrDrawer.Footer>
      </SwapDialog>
      <H2SwapSlippageDialog />
    </>
  );
};
